import $ from 'jquery';

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
import './webflow.js';
//import './webflow.events.slider.js';
//import 'remodal';
//import 'justifiedGallery';
//import 'swipebox';
//import 'jquery-modal';

var WebFont = require('webfontloader') ;
/**
 * Anonymous function is autoexecutable.
 */
WebFont.load({  google: {    families: ["Montserrat:100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic","Amiri:regular,700","Source Sans Pro:regular,700"]  }});

$(document).ready(() => {





});
